<app-request-an-insurance-quote mainHeading="QUOTE REQUEST" subHeading="false">
</app-request-an-insurance-quote>

<!-- A D D R E S S -->

<!-- A D D R E S S -->

<section id="rtq-form-2" class="pb-2">
    <div class="container">
        <div class="row justify-content-center top-border-element">
            <div class="col-md-7 col-xs-12 pt-5">
                <span>Important Notice</span>
                <p class="text-justify mb-0 credit-auth-p">
                    Many nationally recognized insurance companies as well as regional insurance companies require
                    their agents to obtain credit and loss history information on potential customers prior to
                    approving
                    them for a Homeowner or Auto insurance quote. Your individual insurance score and prior loss
                    history information is used as an element of their underwriting selection process. Running of this
                    insurance score is considered a soft hit and does not impact your credit ratings.
                </p>
                <p class="text-justify mb-0 credit-auth-p">
                    Westwood Insurance Agency must have your verbal or written
                    authorization to run your insurance score and loss history information in order
                    to provide the most accurate and most preferred rate available through our
                    various insurance markets.
                </p>
                <p class="text-justify mb-0 credit-auth-p font-weight-bold">
                    Please check the authorization section below entitled "Credit Authorization Form", which will
                    enable us to provide a more accurate quote from all of our companies.
                </p>

                <p class="text-justify mb-0 credit-auth-p font-weight-bold">
                    Note: Completion of this form is not applicable in the following states: CA and MD
                </p>
            </div>
        </div>
    </div>
</section>

<!-- C U S T O M E R   I N F O  -->
<form (ngSubmit)="onSubmit(creditAuthForm)" #creditAuthForm="ngForm" autocomplete="off">
    <section id="rtq-form" class="pb-5">
        <div class="container">
            <img src="assets/img/PRELOADER.gif" class="preloader" *ngIf="isLoading" />
            <div class="row justify-content-center">
                <div class="col-md-7 col-xs-12">
                    <div class="form-div z-indexHeader">
                        <div class="row pl-3">
                            <h5 class="credit-auth-header">Credit Authorization Form</h5>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <p class="text-justify mb-0 credit-auth-p">
                                    Personal information about you, including information from a credit report, may
                                    be collected from persons other than you in connection with this application
                                    for insurance and subsequent amendments and renewals. Credit scoring
                                    information may be used to determine either your eligibility for insurance or
                                    the premium you will be charged. We may use a third party in connection with
                                    the development of your score. Such information as well as other personal and
                                    privileged information collected by us or our agents may in certain
                                    circumstances be disclosed to third parties without your authorization. You
                                    have the right to review your personal information in our files and can request
                                    correction of any inaccuracies.
                                </p>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblrdCreditResponse">Please choose one of the following options
                                    <span>*</span></label>
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="leadDetails.creditAuth.creditAuthorized"
                                            value="No"
                                            (click)="this.commonService.FormatRadioButton($event,1);leadDetails.creditAuth.creditAuthorized='Yes';"
                                            #IscreditAuthorized="ngModel" name="rdCreditResponse" ngDefaultControl
                                            required
                                            [ngClass]="{'active': leadDetails.creditAuth.creditAuthorized== 'Yes'}"
                                            class="radio-btn btn btn-outline-dark">
                                            YES. I/We hereby authorize Westwood Insurance Agency to obtain and analyze
                                            personal credit and loss history for me/us from a credit reporting bureau
                                            for the purpose of underwriting insurance products for me/us.
                                        </button>

                                    </div>
                                    <div class="row pl-0 pt-2 pb-3"
                                        *ngIf="leadDetails.creditAuth.creditAuthorized=='Yes' && !hideSSN ">
                                        <label for="Social-security">Social Security Number</label>
                                        <input type="text" class="form-control form-control-sm ssn w-custom-SSN"
                                            [(ngModel)]="leadDetails.creditAuth.ssn" #ssn="ngModel" name="ssn"
                                            placeholder="Social Security Number" minlength="9" mask="000-00-0000"
                                            [autofocus]="leadDetails.creditAuth.creditAuthorized=='Yes' " />
                                        <label
                                            *ngIf="leadDetails.creditAuth.ssn.length!=0&&leadDetails.creditAuth.ssn.length<9 && ssn.touched && leadDetails.creditAuth.creditAuthorized=='Yes' "
                                            class="error-message text-nowrap">
                                            {{constantsObj.invalidFormatErrorMessage}} </label>
                                    </div>
                                    <div class="row pl-0 pt-2 pb-3"
                                        *ngIf="leadDetails.creditAuth.creditAuthorized=='Yes' && leadDetails.creditAuth.ssn!=''  && leadDetails.creditAuth.ssn.length==9 && hideSSN">
                                        <label for="Social-security">Social security number<span> </span></label>
                                        <input type="text" disabled
                                            class="form-control form-control-sm ssn w-custom-SSN" value="SSN on file">
                                    </div>
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="leadDetails.creditAuth.creditAuthorized"
                                            value="No"
                                            (click)="this.commonService.FormatRadioButton($event,0);leadDetails.creditAuth.creditAuthorized='No';"
                                            #IscreditAuthorized="ngModel" name="rdCreditResponse" ngDefaultControl
                                            required
                                            [ngClass]="{'active': leadDetails.creditAuth.creditAuthorized== 'No'}"
                                            class="radio-btn btn btn-outline-dark">
                                            NO. I/We do not authorize Westwood Insurance Agency to obtain and analyze
                                            personal credit and loss history for me/us from a credit reporting bureau
                                            for the purpose of underwriting insurance products for me/us. I understand
                                            the rate that may display will not be final as it is based on an assumed
                                            insurance score.
                                        </button>

                                    </div>

                                </div>
                                <label *ngIf="IscreditAuthorized.hasError('required') && IscreditAuthorized?.touched"
                                    class="error-message text-nowrap">
                                    {{constantsObj.selectOneErrorMessage}}
                                </label>
                            </div>

                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <div>
                                    <div class="col pl-0">
                                        <label for="name">Enter your name
                                            here as the person completing this form
                                            <span>*</span></label>
                                        <input type="text" autocomplete="creditAuthName" class="form-control"
                                            placeholder="Name" maxlength="35" required
                                            [(ngModel)]="leadDetails.creditAuth.authorizedName" name="authorizedName"
                                            #authorizedName="ngModel" />
                                        <label *ngIf="(authorizedName.hasError('required') && authorizedName.touched) "
                                            class="error-message text-nowrap">
                                            {{constantsObj.requiredErrorMessage}}
                                        </label>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <p>See below for our Privacy Policy</p>
                            </div>
                        </div>

                    </div>

                    <div class="container pt-4">
                        <div class="row">
                            <p class="req-msg-note">*These fields are required</p>
                        </div>
                    </div>

                    <!-- Button -->
                    <div class="row">
                        <div class="col">
                            <button type="button" tabindex="-1"
                                class="btn angled-button-sm button-width-110 button-align-mob-previous previous-left"
                                (click)="commonService.NavigateToPage('real-time-quote/cust-info')">
                                <span>Previous</span>
                            </button>
                        </div>
                        <div class="col">
                            <button type="submit" class="btn angled-button-sm button-align-mob-next btn-next-120">
                                <span>Next</span>
                            </button>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <button type="button" class="btn angled-button-sm button-width-190 button-align-mob-center"
                            (click)="this.popUp.openModal()">
                            <span>Please contact me</span>
                        </button>
                    </div>
                    <!-- // Button -->
                </div>
            </div>
        </div>
    </section>

    <app-model-popup (savePageDetails)="savePageDetails()"></app-model-popup>
</form>
<!-- // C U S T O M E R   I N F O -->